import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { DataPointModel } from '../../../../Charts/models/data-point.model';
import { indexOf } from 'underscore';

@Component({
    selector: 'agpr-list-stacked-bar-card',
    templateUrl: './list-stacked-bar-card.component.html',
    styleUrls: ['./list-stacked-bar-card.component.scss'],
    standalone: false
})
export class ListStackedBarCardComponent implements OnInit {

    @Input() data: DataPointModel;
    @Input() small: boolean = false;

    cumulatedCount: number;
    tooltipText: string;
    ariaLabelText: string;

    readonly buttonTypes = ButtonTypesEnum;

    constructor (
        private router: Router,
    ) { }
    ngOnInit(): void {
        this.cumulatedCount = +this.data.value0 + +this.data.value1 + +this.data.value2 + +this.data.value3;
        this.tooltipText =  this.formatTooltip(this.data.tooltipInfo);
        this.ariaLabelText = this.formatTooltip(this.data.tooltipHtml);
    }

    stripHtml(html: string): string {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    formatTooltip(info: any): string {
        if (typeof info === 'string') {
            return info;
        } else if (typeof info === 'number') {
            return info.toString();
        } else if (typeof info === 'object' && info !== null) {
            return JSON.stringify(info);
        }
        return '';
    }

    onMouseEnter() {
        this.tooltipText = this.formatTooltip(this.data.tooltipHtml);
        this.ariaLabelText = this.stripHtml(this.tooltipText);
    }

    onMouseLeave() {
        this.tooltipText = this.formatTooltip(this.data.tooltipInfo);
        this.ariaLabelText = this.tooltipText;
    }

    navigateToRoute(): void {
        if (this.data.route) {
            this.router.navigate([this.data.route]);
        }
    }
}
